import React from 'react';
import {
    Box,
    Card,
    Typography,
    TextField,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button
} from '@material-ui/core';

const QuotePageOverlayAdd = ({
    open,
    item,
    quantity,
    observation,
    priceOption,
    userRole,
    onQuantityChange,
    onObservationChange,
    onPriceOptionChange,
    onCancel,
    onConfirm,
    formatCurrency,
    classes = {},
    currentLanguage
}) => {
    if (!open || !item) return null;

    return (
        <Box style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.6)',
            zIndex: 2000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <Card style={{
                backgroundColor: 'white',
                borderRadius: 8,
                padding: 24,
                width: 420,
                maxWidth: '95%',
                boxShadow: 5,
            }}>
                <Typography variant="h6" gutterBottom>
                    {currentLanguage.bepiService.shared.shared_details_add_btn} {item.nome}
                </Typography>

                <TextField
                    fullWidth
                    label={currentLanguage.bepiService.workshop.workshop_quote_form_table_qty}
                    type="number"
                    value={quantity}
                    onChange={onQuantityChange}
                    margin="normal"
                    inputProps={{ min: 1 }}
                />

                {userRole === 'admin' && (
                    <FormControl component="fieldset" margin="normal">
                        <Typography variant="subtitle1">{currentLanguage.bepiService.workshop.workshop_quotations_table_value}</Typography>
                        <RadioGroup
                            value={priceOption}
                            onChange={onPriceOptionChange}
                        >
                            <FormControlLabel
                                value={item.valor.toString()}
                                control={<Radio />}
                                label={`${currentLanguage.bepiService.workshop.workshop_quote_overlay_normal_price}: ${formatCurrency(item.valor)}`}
                            />
                            <FormControlLabel
                                value={item.valor_2.toString()}
                                control={<Radio />}
                                label={`${currentLanguage.bepiService.workshop.workshop_quote_overlay_promo_price}: ${formatCurrency(item.valor_2)}`}
                            />
                        </RadioGroup>
                    </FormControl>
                )}

                <TextField
                    fullWidth
                    label={currentLanguage.bepiService.shared.shared_resp_form_obs_label}
                    value={observation}
                    onChange={onObservationChange}
                    margin="normal"
                    placeholder={currentLanguage.bepiService.shared.shared_optional_label}
                />

                <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
                    <Button
                        onClick={onCancel}
                        color="secondary"
                    >
                        {currentLanguage.bepiService.shared.shared_details_cancel_btn}
                    </Button>
                    <Button
                        onClick={onConfirm}
                        variant="contained"
                        color="primary"
                    >
                        {currentLanguage.bepiService.shared.shared_details_add_btn}
                    </Button>
                </Box>
            </Card>
        </Box>
    );
};

export default QuotePageOverlayAdd;
